// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".circle--left[data-v-7b4d09de]{position:absolute;left:0;bottom:15%;transform:translateX(-40%)}.circle--right[data-v-7b4d09de]{opacity:.2;position:absolute;right:0;top:0;transform:translateY(-20%)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
